import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'lib-chat-ticket-list',
  templateUrl: './chat-ticket-list.component.html',
  styleUrls: ['./chat-ticket-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatTicketListComponent implements OnInit {
  @Input() ticketsList: any;
  @Input() set selected(id: any) {
    if(id) {
      this.selectedItemId = id;
      this.cd.detectChanges()
    }
  }
  @Output() onSelectTicket = new EventEmitter<any>()
  selectedItemId: string = '';
  textLimit = 70;

  constructor(
    private cd: ChangeDetectorRef,
  ) { }

  ngOnInit() {
  }

  getUserInitialsFromName(fullName: any) {
    if (!fullName) return 'N/A';
    const splitName = fullName?.trim().split(' ');
    return splitName.length > 1 ? splitName[0][0] + (splitName[1][0] ? splitName[1][0] : '') : splitName[0][0]
  }

  editDescription(text: string) {
    return text? text.length < this.textLimit ? text : `${text?.substring(0, this.textLimit)} ...` : null;
  }

  selectTicket(item: any) {
    if(this.selectedItemId != item.id) {
      this.selectedItemId = item.id;
      this.onSelectTicket.emit(item)
    }
    
  }

  removeUnSeenMessages(ticketId: string) {
    this.ticketsList.map((e: any) => {
      e.unSeenMessages = e.id === ticketId ? 0 : e.unSeenMessages
    })
    this.cd.detectChanges()
  }

}
